import React, { useRef } from 'react';

import { useIntl } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box, Flex, Text } from '@atlaskit/primitives/compiled';
import { Tab } from '@atlaskit/tabs';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

import type { Build } from '../../../types';
import { messages } from '../messages';

import { BuildTabIcon } from './build-tab-icon';

const styles = cssMap({
	container: {
		paddingTop: token('space.050'),
		paddingBottom: token('space.050'),
	},
	textContainer: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
});

export const BuildTab = ({
	build,
	label,
	index,
	stepNumber,
}: {
	build: Build;
	label: string;
	index: number;
	stepNumber: number;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();

	const textRef = useRef<HTMLDivElement>(null);
	const isTruncated =
		textRef.current && textRef.current?.scrollWidth > textRef.current?.clientWidth;

	const displayLabel = formatMessage(messages.tabLabelWithStep, { stepNumber, label });

	return (
		<Tooltip content={isTruncated ? displayLabel : null}>
			<Tab>
				<Flex alignItems="center" gap="space.100" xcss={styles.container}>
					<BuildTabIcon build={build} index={index} />
					<Box ref={textRef} xcss={styles.textContainer}>
						<Text>{displayLabel}</Text>
					</Box>
				</Flex>
			</Tab>
		</Tooltip>
	);
};
